// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-dropdown-menu.messages .mat-mdc-menu-panel,
.toolbar-dropdown-menu.messages .mat-menu-panel {
  border-radius: 14px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.13) !important;
  overflow: hidden;
  min-width: 320px !important;
  max-width: 340px !important;
}
.toolbar-dropdown-menu.messages .mat-mdc-menu-content,
.toolbar-dropdown-menu.messages .mat-menu-content {
  padding: 0 !important;
}

.messages .notif-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  background: #fff;
}
.messages .notif-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.01em;
}
.messages .notif-panel-badge {
  background: #e53935;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 10px;
  padding: 2px 7px;
  line-height: 15px;
  min-width: 20px;
  text-align: center;
  display: inline-block;
}
.messages .notif-scroll-wrap {
  height: 340px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
}
.messages .notif-scroll-wrap.notif-empty {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.messages .notif-scroll-wrap::-webkit-scrollbar {
  width: 4px;
}
.messages .notif-scroll-wrap::-webkit-scrollbar-track {
  background: transparent;
}
.messages .notif-scroll-wrap::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.messages .notif-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px 12px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.055);
  cursor: pointer;
  position: relative;
  transition: background 0.15s ease;
  background: #fff;
}
.messages .notif-row:last-child {
  border-bottom: none;
}
.messages .notif-row:hover {
  background: #f4f8ff;
}
.messages .notif-row:hover .notif-dismiss {
  opacity: 1;
}
.messages .notif-row--unread {
  background: #f8fbff;
}
.messages .notif-unread-bar {
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--color-primary);
  flex-shrink: 0;
}
.messages .notif-avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #daeeff;
  background: #daeeff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}
.messages .notif-avatar--read {
  opacity: 0.75;
  border-color: #e8e8e8;
  background: #e8e8e8;
}
.messages .notif-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}
.messages .notif-avatar__initials {
  font-size: 13px;
  font-weight: 700;
  color: var(--color-primary);
  line-height: 1;
  letter-spacing: 0.02em;
}
.messages .notif-content {
  flex: 1;
  min-width: 0;
  padding-inline-end: 20px;
}
.messages .notif-content__sender {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 1px;
}
.messages .notif-content__title {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-primary);
  line-height: 1.3;
  margin-bottom: 2px;
}
.messages .notif-content__body {
  font-size: 12px;
  color: #555;
  line-height: 1.5;
  white-space: normal;
  text-align: start;
  margin-bottom: 5px;
  word-break: break-word;
}
.messages .notif-content__time {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: #aaa;
  justify-content: flex-end;
}
.messages .notif-content__time mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #ccc;
}
.messages .notif-dismiss {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s, color 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.messages .notif-dismiss mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: #bbb;
}
.messages .notif-dismiss:hover mat-icon {
  color: #d32f2f;
}
.messages .notif-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  color: #bbb;
}
.messages .notif-empty-state mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
}
.messages .notif-empty-state span {
  font-size: 13px;
  text-align: center;
  color: #aaa;
}

.notification-button {
  position: relative;
}
.notification-button .notification-count {
  position: absolute;
  top: 4px;
  inset-inline-end: 2px;
  z-index: 2;
  background-color: #e53935;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.95);
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/messages/messages.component.scss"],"names":[],"mappings":"AAOI;;EAEI,8BAAA;EACA,qDAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;AANR;AASI;;EAEI,qBAAA;AAPR;;AAgBI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,4CAAA;EACA,gBAAA;AAbR;AAgBI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAdR;AAiBI;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAfR;AAqBI;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAnBR;AAqBQ;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnBZ;AAsBQ;EACI,UAAA;AApBZ;AAuBQ;EACI,uBAAA;AArBZ;AAwBQ;EACI,+BAAA;EACA,kBAAA;AAtBZ;AA6BI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,4BAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;AA3BR;AA6BQ;EACI,mBAAA;AA3BZ;AA8BQ;EACI,mBAAA;AA5BZ;AA8BY;EACI,UAAA;AA5BhB;AAgCQ;EACI,mBAAA;AA9BZ;AAmCI;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,gCAAA;EACA,cAAA;AAjCR;AAuCI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AArCR;AAuCQ;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;AArCZ;AAyCI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAvCR;AA0CI;EACI,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,sBAAA;AAxCR;AA8CI;EACI,OAAA;EACA,YAAA;EACA,wBAAA;AA5CR;AA+CI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AA7CR;AAgDI;EACI,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AA9CR;AAiDI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AA/CR;AAkDI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AAhDR;AAkDQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAhDZ;AAuDI;EACI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AArDR;AAuDQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AArDZ;AAwDQ;EACI,cAAA;AAtDZ;AA6DI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;AA3DR;AA6DQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;AA3DZ;AA8DQ;EACI,eAAA;EACA,kBAAA;EACA,WAAA;AA5DZ;;AAoEA;EACI,kBAAA;AAjEJ;AAmEI;EACI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,+CAAA;AAjER","sourcesContent":["// ==========================================================================\r\n// Component: Messages\r\n// ==========================================================================\r\n\r\n// Menu panel override — rounded corners + shadow\r\n.toolbar-dropdown-menu.messages {\r\n\r\n    .mat-mdc-menu-panel,\r\n    .mat-menu-panel {\r\n        border-radius: 14px !important;\r\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.13) !important;\r\n        overflow: hidden;\r\n        min-width: 320px !important;\r\n        max-width: 340px !important;\r\n    }\r\n\r\n    .mat-mdc-menu-content,\r\n    .mat-menu-content {\r\n        padding: 0 !important;\r\n    }\r\n}\r\n\r\n.messages {\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Panel header\r\n    // -----------------------------------------------------------------------\r\n    .notif-panel-header {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        padding: 14px 16px 12px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.07);\r\n        background: #fff;\r\n    }\r\n\r\n    .notif-panel-title {\r\n        font-size: 14px;\r\n        font-weight: 700;\r\n        color: #1a1a1a;\r\n        letter-spacing: -0.01em;\r\n    }\r\n\r\n    .notif-panel-badge {\r\n        background: #e53935;\r\n        color: #fff;\r\n        font-size: 10px;\r\n        font-weight: 700;\r\n        border-radius: 10px;\r\n        padding: 2px 7px;\r\n        line-height: 15px;\r\n        min-width: 20px;\r\n        text-align: center;\r\n        display: inline-block;\r\n    }\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Scroll wrapper\r\n    // -----------------------------------------------------------------------\r\n    .notif-scroll-wrap {\r\n        height: 340px;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n        background: #fff;\r\n\r\n        &.notif-empty {\r\n            height: 130px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n        }\r\n\r\n        &::-webkit-scrollbar {\r\n            width: 4px;\r\n        }\r\n\r\n        &::-webkit-scrollbar-track {\r\n            background: transparent;\r\n        }\r\n\r\n        &::-webkit-scrollbar-thumb {\r\n            background: rgba(0, 0, 0, 0.12);\r\n            border-radius: 4px;\r\n        }\r\n    }\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Notification row\r\n    // -----------------------------------------------------------------------\r\n    .notif-row {\r\n        display: flex;\r\n        align-items: flex-start;\r\n        gap: 10px;\r\n        padding: 12px 14px 12px 10px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.055);\r\n        cursor: pointer;\r\n        position: relative;\r\n        transition: background 0.15s ease;\r\n        background: #fff;\r\n\r\n        &:last-child {\r\n            border-bottom: none;\r\n        }\r\n\r\n        &:hover {\r\n            background: #f4f8ff;\r\n\r\n            .notif-dismiss {\r\n                opacity: 1;\r\n            }\r\n        }\r\n\r\n        &--unread {\r\n            background: #f8fbff;\r\n        }\r\n    }\r\n\r\n    // Left accent bar for unread\r\n    .notif-unread-bar {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 10px;\r\n        bottom: 10px;\r\n        width: 3px;\r\n        border-radius: 0 3px 3px 0;\r\n        background: var(--color-primary);\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Avatar\r\n    // -----------------------------------------------------------------------\r\n    .notif-avatar {\r\n        flex-shrink: 0;\r\n        width: 40px;\r\n        height: 40px;\r\n        border-radius: 50%;\r\n        overflow: hidden;\r\n        border: 2px solid #daeeff;\r\n        background: #daeeff;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin-top: 1px;\r\n\r\n        &--read {\r\n            opacity: 0.75;\r\n            border-color: #e8e8e8;\r\n            background: #e8e8e8;\r\n        }\r\n    }\r\n\r\n    .notif-avatar__img {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        border-radius: 50%;\r\n        display: block;\r\n    }\r\n\r\n    .notif-avatar__initials {\r\n        font-size: 13px;\r\n        font-weight: 700;\r\n        color: var(--color-primary);\r\n        line-height: 1;\r\n        letter-spacing: 0.02em;\r\n    }\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Content\r\n    // -----------------------------------------------------------------------\r\n    .notif-content {\r\n        flex: 1;\r\n        min-width: 0;\r\n        padding-inline-end: 20px;\r\n    }\r\n\r\n    .notif-content__sender {\r\n        font-size: 13px;\r\n        font-weight: 700;\r\n        color: #1a1a1a;\r\n        line-height: 1.4;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        margin-bottom: 1px;\r\n    }\r\n\r\n    .notif-content__title {\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        color: var(--color-primary);\r\n        line-height: 1.3;\r\n        margin-bottom: 2px;\r\n    }\r\n\r\n    .notif-content__body {\r\n        font-size: 12px;\r\n        color: #555;\r\n        line-height: 1.5;\r\n        white-space: normal;\r\n        text-align: start;\r\n        margin-bottom: 5px;\r\n        word-break: break-word;\r\n    }\r\n\r\n    .notif-content__time {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 3px;\r\n        font-size: 11px;\r\n        color: #aaa;\r\n        justify-content: flex-end;\r\n\r\n        mat-icon {\r\n            font-size: 12px;\r\n            width: 12px;\r\n            height: 12px;\r\n            color: #ccc;\r\n        }\r\n    }\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Dismiss button\r\n    // -----------------------------------------------------------------------\r\n    .notif-dismiss {\r\n        position: absolute;\r\n        top: 8px;\r\n        inset-inline-end: 8px;\r\n        background: none;\r\n        border: none;\r\n        padding: 2px;\r\n        cursor: pointer;\r\n        opacity: 0;\r\n        transition: opacity 0.15s, color 0.15s;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 50%;\r\n\r\n        mat-icon {\r\n            font-size: 15px;\r\n            width: 15px;\r\n            height: 15px;\r\n            color: #bbb;\r\n        }\r\n\r\n        &:hover mat-icon {\r\n            color: #d32f2f;\r\n        }\r\n    }\r\n\r\n    // -----------------------------------------------------------------------\r\n    // Empty state\r\n    // -----------------------------------------------------------------------\r\n    .notif-empty-state {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        gap: 8px;\r\n        padding: 24px;\r\n        color: #bbb;\r\n\r\n        mat-icon {\r\n            font-size: 32px;\r\n            width: 32px;\r\n            height: 32px;\r\n        }\r\n\r\n        span {\r\n            font-size: 13px;\r\n            text-align: center;\r\n            color: #aaa;\r\n        }\r\n    }\r\n}\r\n\r\n// ==========================================================================\r\n// Bell button & badge\r\n// ==========================================================================\r\n.notification-button {\r\n    position: relative;\r\n\r\n    .notification-count {\r\n        position: absolute;\r\n        top: 4px;\r\n        inset-inline-end: 2px;\r\n        z-index: 2;\r\n        background-color: #e53935;\r\n        color: #fff;\r\n        font-size: 11px;\r\n        font-weight: 700;\r\n        line-height: 1;\r\n        border-radius: 10px;\r\n        min-width: 18px;\r\n        height: 18px;\r\n        padding: 0 5px;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        box-sizing: border-box;\r\n        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.95);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
